/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react';
import http from 'utilities/http';
import Link from 'next/link';
import Image from 'next/image';
import { API_URL_V2, POST_TYPE_MAPPING } from '../../../utilities/constants';
import { isUndefined } from 'lodash';
import ArticleComponent, {
    ArticleSmall,
} from 'components/cong-dong/articleComponent';
import { getCookie } from 'framework/libs/cookie';
import { TOKEN_CONGDONG } from 'framework/store/constants';
import { isEmpty } from 'lodash';
import StarList from 'components/shop/review/starList';
import axios from 'axios';
import { Button, Col, Modal, Row, Space } from 'antd';

export default function Index({ profession }) {
    const [articlesG, setArticlesG] = useState([]);
    const [albumsG, setAlbumsG] = useState([]);
    const [reviews, setReviews] = useState([]);
    const fetchData = async (type) => {
        const token = !isEmpty(getCookie(TOKEN_CONGDONG))
            ? 'Bearer ' + getCookie(TOKEN_CONGDONG)
            : 'default';
        try {
            if (type == 'article') {
                let url = `community/professional/${profession.id}/articles?page=1&per_page=6`;
                const response = await http(url, {}, { token: token }, 'v2');
                // response.data = articlesG?.data.concat(response?.data);
                if (response.code == 200) {
                    setArticlesG(response);
                    return;
                }
            } else if (type == 'albums') {
                let url = `community/professional/${profession.id}/albums?page=1&per_page=10`;
                const response = await http(url, {}, { token: token }, 'v2');
                // response.data = albumsG?.data.concat(response?.data);
                setAlbumsG(response);
                if (response.code == 200) {
                    setAlbumsG(response);
                    return;
                }
            }
        } catch (e) {
            console.log(e.message);
        }
    };
    const fetchReview = async () => {
        let url = `community/professional/${profession.id}/reviews?page=1&per_page=${5}`;
        const response = await http(url, {}, { token: getCookie(TOKEN_CONGDONG) }, 'v2');
        setReviews(response?.data || []);
    };
    useEffect(() => {
        fetchData('article');
        fetchData('albums');
        fetchReview();
    }, []);

    const genImage = function (w, h, link) {
        if (!isUndefined(link)) {
            return <Image width={w} height={h} src={link} alt="" />;
        }
    };
    const genReview = !isEmpty(reviews?.data) && (
        <ul className="comment__best-list">
            {reviews?.data?.slice(0, 2).map((item, index) => {
                return (
                    <li key={index}>
                        <Link
                            key={index}
                            href={'/review/' + item?.id + '/' + item?.slug}
                        >
                            <a>
                                <div
                                    className="inner"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="comment-head">
                                        <div className="user-thumb">
                                            {genImage(
                                                40,
                                                40,
                                                item?.user?.avatar,
                                            )}
                                        </div>
                                        <div className="user-info">
                                            <span className="user-name">
                                                {item?.user?.display_name}
                                            </span>
                                            <StarList number={item?.rating} />
                                        </div>
                                    </div>
                                    <div className="comment-body">
                                        <p className="comment-text">
                                            {item?.title}
                                        </p>
                                        <span className="commont-img">
                                            {genImage(
                                                56,
                                                56,
                                                item?.storage_thumbnail_url,
                                            )}
                                            {/*<Image width={56} height={56} src="/images/home-review-thumb-2.png" alt=""/>*/}
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </Link>
                    </li>
                );
            })}
        </ul>
    );

    return (
        <>
            <Space direction="vertical" size={40}>
                <CongTrinh professionId={profession.id} />
                {!isEmpty(reviews?.data) && (
                    <div className="bb-sp mb-4">
                        <div className="groupCategory-title">
                            <h3 className="groupCategory-tlt">Đánh giá</h3>
                            <Link href={'./' + profession?.id + '?t=danh-gia'}>
                                <a className="">Xem tất cả</a>
                            </Link>
                        </div>
                        {genReview}
                    </div>
                )}
                {!isEmpty(articlesG?.data) && (
                    <div className="bb-sp mb-sm-0 pt-0 pb-0 main--photoStore">
                        <div className="groupCategory-title">
                            <h3 className="groupCategory-tlt">
                                Bài viết nổi bật
                            </h3>
                            <Link href={'./' + profession.id + '?t=bai-viet'}>
                                <a className="color-main">Xem tất cả</a>
                            </Link>
                        </div>
                        <div className="lstPhoto">
                            <ul>
                                {articlesG?.data
                                    ?.slice(0, 6)
                                    .map((article, index) => {
                                        return (
                                            <ArticleComponent
                                                key={index}
                                                item={article}
                                                index={index}
                                                slug={'chuyen-nha'}
                                                isUserPage={true}
                                            ></ArticleComponent>
                                        );
                                    })}
                            </ul>
                            {/* {genMoreArticle()} */}
                        </div>
                    </div>
                )}
                {!isEmpty(albumsG?.data) && (
                    <div className="mb-4">
                        <div className="groupCategory-title">
                            <h3 className="groupCategory-tlt">
                                Hình ảnh nổi bật
                            </h3>
                            <Link href={'./' + profession?.id + '?t=hinh-anh'}>
                                <a className="color-main">Xem tất cả</a>
                            </Link>
                        </div>
                        <div className="gallery__featured">
                            <ul className="gallery__featured-img">
                                {albumsG?.data?.map((photo, index) => {
                                    return (
                                        <li
                                            key={index}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Link
                                                href={
                                                    '/' +
                                                    POST_TYPE_MAPPING[
                                                        photo?.post_type_id
                                                    ] +
                                                    photo?.id +
                                                    '/' +
                                                    photo?.slug
                                                }
                                            >
                                                <a className="wrap-next-image">
                                                    <Image
                                                        width={139}
                                                        height={139}
                                                        src={
                                                            photo?.storage_thumbnail_url
                                                        }
                                                        alt=""
                                                    />
                                                </a>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        {/* {genMoreAlbums()} */}
                    </div>
                )}
            </Space>

            {isEmpty(albumsG?.data) &&
                isEmpty(articlesG?.data) &&
                isEmpty(reviews?.data) && (
                <div className="expert__wrap-content expert-voucher">
                    <div className="voucher-none">
                        <div className="thumb">
                            <img src="/images/icon-no-data.svg" alt="" />
                        </div>
                        <p className="text">Chưa có bài viết nào</p>
                    </div>
                </div>
            )}
        </>
    );
}

export const CongTrinh = ({ professionId }) => {
    const [articles, setArticles] = useState([]);
    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await axios.get(
                    API_URL_V2 + 'project-introduction',
                    {
                        params: {
                            per_page: 3,
                            professional_id: professionId,
                        },
                    },
                );
                if (!isEmpty(res.data.data)) {
                    setArticles(res.data.data);
                }
            } catch (e) {
                console.log(e);
            }
        };
        fetch();
    }, []);

    return (
        <>
            {!isEmpty(articles) && (
                <div
                    className="px-24px pt-24px m-px-16px m-ml--16px m-mr--16px position-relative border-radius-12 m-border-radius-0"
                    style={{
                        background: '#F0FBFF',
                        overflow: 'hidden',
                    }}
                >
                    <p className="font-size-20 font-weight-600 color-blue">
                        Công trình Happynest giới thiệu
                    </p>
                    <img
                        src="/chuyen-gia/box-cong-trinh.svg"
                        className="position-absolute pc-only"
                        style={{ top: 0, right: 0 }}
                    />
                    <Row className="mt-26px mb-24px" gutter={[20, 20]}>
                        {articles.map((item, index) => {
                            return (
                                <Col key={index} md={8} xs={24}>
                                    <ArticleSmall
                                        key={index}
                                        item={item}
                                        index={index}
                                        slug={'chuyen-nha'}
                                        isUserPage={false}
                                    />
                                </Col>
                            );
                        })}
                    </Row>
                    <Button
                        style={{
                            background: '#BDE8FF',
                            color: '#278FF7',
                            border: 'none',
                            borderRadius: 0,
                            width: 'calc(100% + 48px)',
                            height: 48,
                            marginLeft: '-24px',
                        }}
                    >
                        Xem tất cả
                    </Button>
                </div>
            )}
        </>
    );
};
